export * from '@gongxigames/framework/slotV2/modules/infoSystem/InfoSystemModule';
